var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 13.6,
    viewBox: "0 0 17 13.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".svgicon-feedback-a{fill:#01c6d9;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "svgicon-feedback-a",
    d: "M18.3,6H4.7A1.7,1.7,0,0,0,3.009,7.7L3,17.9a1.7,1.7,0,0,0,1.7,1.7H18.3A1.7,1.7,0,0,0,20,17.9V7.7A1.7,1.7,0,0,0,18.3,6Zm0,3.4-6.8,4.25L4.7,9.4V7.7l6.8,4.25L18.3,7.7Z",
    transform: "translate(-3 -6)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.591df8d3.svg";
export { ForwardRef as ReactComponent };